import printPageLayout from '../../../html/widget_print_content.html?raw';

export type PrintPageOptions = {
    title?: string;
    cssUrls?: string[];
    removeDelayMs?: number;
};

export class PrintPage {
    private contentHtml: string;
    private document: Document;

    private title: string;
    private cssUrls: string[];
    private removeDelayMs: number;

    constructor(document: Document, contentHtml: string, opts: PrintPageOptions = {}) {
        this.contentHtml = contentHtml;
        this.document = document;
        this.title = opts.title ?? 'Chat-Verlauf';
        this.cssUrls = opts.cssUrls ?? [];
        this.removeDelayMs = opts.removeDelayMs ?? 1000;
    }

    public async show(): Promise<void> {
        const iFrame = this.generateIFrame();
        this.document.body.appendChild(iFrame);

        const doc = iFrame.contentDocument!;
        const win = iFrame.contentWindow!;

        doc.open();
        doc.write(printPageLayout);

        await this.loadCss(doc);
        this.attachContent(doc, this.contentHtml)
        doc.close();

        Promise.race([this.waitForDocumentReady(this.document), this.timeoutPromise(6000)])
            .then(async () => {
                await this.print(win);
            })
            .finally(() => {
                this.removeIFrame(iFrame);
            });
    }

    private waitForDocumentReady(doc: Document): Promise<void> {
        return new Promise<void>((resolve) => {
            // Bereits fertig?
            if (doc.readyState === 'complete') {
                resolve();
                return;
            }

            const onReadyStateChange = () => {
                if (doc.readyState === 'complete') {
                    doc.removeEventListener('readystatechange', onReadyStateChange);
                    resolve();
                }
            };

            doc.addEventListener('readystatechange', onReadyStateChange);
        });
    }

    private timeoutPromise(timeout: number): Promise<void> {
        return new Promise<void>((resolve) => setTimeout(resolve, timeout));
    }

    private generateIFrame():HTMLIFrameElement {
        let iFrame = this.document.createElement('iframe');
        iFrame.style.position = 'fixed';
        iFrame.style.right = '0';
        iFrame.style.bottom = '0';
        iFrame.style.width = '0';
        iFrame.style.height = '0';
        iFrame.style.border = '0';
        iFrame.setAttribute('aria-hidden', 'true');

        return iFrame;
    }

    private attachContent(doc: Document, content:string)  {
        doc.title = this.title;
        let root = doc.getElementById('print-root');
        if (root) {
            root.innerHTML = content;
        } else {
            doc.body.innerHTML = content;
        }
    };

    private async print(win: WindowProxy) {
        await new Promise(r => setTimeout(r, 50));
        win.focus();
        win.print();
    }

    private removeIFrame(iframe: HTMLIFrameElement) {
        setTimeout(() => {
            iframe.remove();
        }, this.removeDelayMs);
    }

    private async loadCss(doc: Document): Promise<void> {
        for (const href of this.cssUrls) {
            try {
                await this.loadCssIntoDoc(doc, href);
            } catch (e) {
                console.warn('[print] CSS konnte nicht geladen werden:', href, e);
            }
        }
    }

    private async loadCssIntoDoc(doc: Document, href: string): Promise<void> {
        await new Promise<void>((resolve, reject) => {
            const link = doc.createElement('link');
            link.rel = 'stylesheet';
            link.href = href;
            link.onload = () => resolve();
            doc.head.appendChild(link);
        });

        await new Promise(r => setTimeout(r, 20));
    }

}
